// services/photo.js
import api from './api';

const photoService = {
  /**
   * Liker ou unliker une photo
   */
  likePhoto: async (photoId, userId) => {
    try {
      const response = await api.post('/like-photo.php', {
        photo_id: photoId,
        user_id: userId
      });

      if (response.data.success) {
        return {
          success: true,
          action: response.data.action,
          likes: response.data.likes
        };
      } else {
        return {
          success: false,
          error: response.data.error
        };
      }
    } catch (error) {
      console.error('❌ likePhoto error:', error);
      return {
        success: false,
        error: error.message
      };
    }
  },

  /**
   * Incrémenter les vues d'une photo
   */
  incrementViews: async (photoId) => {
    try {
      const response = await api.post('/increment-photo-views.php', {
        photo_id: photoId
      });

      if (response.data.success) {
        return {
          success: true,
          views: response.data.views
        };
      } else {
        return {
          success: false,
          error: response.data.error
        };
      }
    } catch (error) {
      console.error('❌ incrementViews error:', error);
      return { 
        success: false, 
        error: error.message 
      };
    }
  },

  /**
   * Récupérer les commentaires d'une photo
   */
  getComments: async (photoId) => {
    try {
      const response = await api.get('/get-photo-comments.php', {
        params: { photo_id: photoId }
      });

      if (response.data.success) {
        return {
          success: true,
          comments: response.data.comments
        };
      } else {
        return {
          success: false,
          comments: [],
          error: response.data.error
        };
      }
    } catch (error) {
      console.error('❌ getComments error:', error);
      return { 
        success: false, 
        comments: [],
        error: error.message 
      };
    }
  },

  /**
   * Ajouter un commentaire
   */
  addComment: async (photoId, userId, comment) => {
    if (!comment || !comment.trim()) {
      return {
        success: false,
        error: 'Le commentaire ne peut pas être vide'
      };
    }

    try {
      const response = await api.post('/add-photo-comment.php', {
        photo_id: photoId,
        user_id: userId,
        comment: comment.trim()
      });

      return response.data;
    } catch (error) {
      console.error('❌ addComment error:', error);
      return { 
        success: false, 
        error: error.message 
      };
    }
  },

  /**
   * Supprimer un commentaire
   */
  deleteComment: async (commentId, userId) => {
    try {
      const response = await api.post('/delete-photo-comment.php', {
        comment_id: commentId,
        user_id: userId
      });

      return response.data;
    } catch (error) {
      console.error('❌ deleteComment error:', error);
      return { 
        success: false, 
        error: error.message 
      };
    }
  }
};

export default photoService;